import React, { useContext } from "react";
import { Developer } from "../../../Customers/types";
import { LangContext } from "../../../../context/lang/LangContext";

interface Props {
  developer: Developer;
  id: string;
}

export const DeveloperCard = ({ developer, id }: Props) => {
  const { messages } = useContext(LangContext);
  return (
    <div id={id} className="DeveloperCard__container">
      <div className="DeveloperCard__header">
        <img src={developer.photo} alt={developer.name} />
        <div className="DeveloperCard__info">
          <span className="DeveloperCard__customer_name">
            {developer.customer_name}
          </span>
          <span className="DeveloperCard__name">
            <b>{developer.name}</b>
          </span>
          <span className="DeveloperCard__role">{developer.role}</span>
        </div>
      </div>
      <p
        dangerouslySetInnerHTML={{
          __html:
            messages.customers.developers[
              developer.id as keyof typeof messages.customers.developers
            ],
        }}
        className="DeveloperCard__body"
      ></p>
    </div>
  );
};
